import React, { RefObject, useEffect, useRef } from 'react';
import style from 'assets/jss/material-dashboard-pro-react/views/services/FixedBusinessBroadband/plansServicesStyle';
import { Link, makeStyles } from '@material-ui/core';
import { translate } from 'components/Translation';
import ConditionalRender from 'components/ConditionalRender/ConditionalRender';

import { BodyM, BodySBold } from 'components/Typography/Typography';
import { useSelector } from 'react-redux';
import { getFiberProLabels } from 'redux/modules/dynamicLabels/selectors';

// @ts-ignore
const useStyles = makeStyles(style);

interface IPlansServicesProps {
	lines: Array<types.services.fixed.IPlansServicesLines>;
	setNextStepDisabled: (nextStepDisabled: boolean) => void;
	hasPlan: (ind: number) => boolean;
	handleDeletePlan: (ind: number) => void;
	handleAddPlan: (ind: number) => void;
}

const PlansServicesTab = (props: IPlansServicesProps) => {
	// this component get focussed - for accessibility
	const ref: RefObject<HTMLDivElement> = useRef(null);
	const fiberProLabels = useSelector(getFiberProLabels);

	useEffect(() => {
		if (ref.current) ref.current.focus();
	}, []);
	const { setNextStepDisabled, lines, hasPlan } = props;
	const classes = useStyles();
	useEffect(() => {
		setNextStepDisabled(true);
	}, [setNextStepDisabled]);

	useEffect(() => {
		setNextStepDisabled(!lines.every((_plan, ind) => hasPlan(ind)));
	}, [setNextStepDisabled, lines, hasPlan]);

	return (
		<div ref={ref}>
			<div className={classes.subtitle}>
				<BodyM color="secondary-light" disableMargin>
					{fiberProLabels.max4Lines}
				</BodyM>
			</div>
			{props.lines.map((line: types.services.fixed.IPlansServicesLines, ind: number) => (
				<React.Fragment key={ind}>
					<div className={classes.lineContainer}>
						<span className={classes.line}>{line.lineEl}</span>
						<span className={classes.addButton}>
							<div>
								<Link
									href="#"
									underline="always"
									className={props.hasPlan(ind) ? classes.removeLine : ''}
									onClick={() => {
										if (props.hasPlan(ind)) props.handleDeletePlan(ind);
										else props.handleAddPlan(ind);
									}}
								>
									<BodySBold
										customClassName={props.hasPlan(ind) ? classes.removePlan : classes.buildPlan}
									>
										{props.hasPlan(ind) ? fiberProLabels.removePlan : fiberProLabels.buildPlan}
									</BodySBold>
								</Link>
							</div>
						</span>
					</div>
					<ConditionalRender
						show={props.hasPlan(ind)}
						onTrue={() => (
							<div className={classes.summary}>
								<span className={classes.summaryContainer}>{line.summaryEl}</span>
							</div>
						)}
					/>
				</React.Fragment>
			))}
		</div>
	);
};

export default PlansServicesTab;
